import "./NewsClasses.scss";

const NewsClasses = ({ data }: any) => {
  return (
    <div className="nc-pill-wrap">
      {data?.length > 0 ? (
        data.map((item: any, index: number) => (
          <span key={index} className="nc-pill">{item}</span>
        ))
      ) : (
        <p className="nc-empty">No data</p>
      )}
    </div>
  );
};

export default NewsClasses;
